// extracted by mini-css-extract-plugin
export default {"container":"_8c072435","imageContainer":"_f77f8b72","image":"_2648b815","content":"_386f7b","soldIcon":"_685320ed","title":"_5ec3c872","buttonContainer":"_bdbedfe3"};